<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 22 22"
  >
    <g :fill="color">
      <path d="M13.232 1.375h4.287c0.267 0 0.482 0.212 0.482 0.47v18.309c0 0.261-0.216 0.47-0.482 0.47h-4.287c-0.002 0-0.005 0-0.008 0-0.261 0-0.473-0.21-0.476-0.47v-18.307c0-0.261 0.216-0.472 0.484-0.472zM4.482 1.375h4.285c0.267 0 0.484 0.212 0.484 0.47v18.309c0 0.261-0.216 0.47-0.484 0.47h-4.285c-0.002 0-0.004 0-0.006 0-0.261 0-0.473-0.21-0.476-0.47v-18.307c0-0.263 0.216-0.472 0.482-0.472z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgPause',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
